import { ACTIONS } from './actions';

export const getInitialState = () => ({
  data: {},
  error: null,
  lastDocument: null,
  loaded: false,
  loading: false,
  next: null,
  gotNewData: true,
});

export const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case ACTIONS.UTI_CWSP_FIRST_BATCH: {
      return {
        ...getInitialState(),
        loading: true,
      };
    }
    case ACTIONS.UTI_CWSP_FIRST_BATCH_ERROR: {
      return {
        ...getInitialState(),
        error: action.payload,
        loaded: true,
      };
    }
    case ACTIONS.UTI_CWSP_RESET: {
      return getInitialState();
    }
    case ACTIONS.UTI_CWSP_NEXT_BATCH: {
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    }
    case ACTIONS.UTI_CWSP_NEXT_BATCH_ERROR: {
      return {
        ...state,
        error: action.payload,
        loaded: true,
        loading: false,
      };
    }
    case ACTIONS.UTI_CWSP_BATCH_SUCCESS: {
      return {
        ...state,
        lastDocument: action.payload.lastDocument || state.lastDocument,
        data: { ...state.data, ...action.payload.data },
        // `hasMore` is the peeked, definitive "more data exists" flag from the
        // main-collection batch. Subcollection realtime updates dispatch this
        // same action without `hasMore` (undefined) and must NOT flip it, so we
        // preserve the previous value in that case.
        gotNewData:
          action.payload.hasMore !== undefined
            ? action.payload.hasMore
            : state.gotNewData,
        next: action.payload.next || state.next,
        loaded: true,
        loading: false,
        error: null,
      };
    }
    default:
      throw new Error('useCollectionWithSubcollectionsPaginated: Invalid action');
  }
};